function compileHTML (fontList) {
  let templateStr = ''
  fontList.forEach((item) => {
    templateStr += `<div class='${item.className}'>${item.content}</div>`
  })
  return templateStr
}

function compileCSS (fontList, isProEnv) {
  let templateStr = ''
  fontList.forEach((item) => {
    if (isProEnv) {
      templateStr += `@font-face {
  font-family:'${item.fontName}';
  src:
    url('./${item.fontName}.woff') format('woff'),
    url('./${item.fontName}.woff2') format('woff2'),
    url('./${item.fontName}.ttf') format('truetype');
  font-display: swap;
}
.${item.className} {
  font-family: '${item.fontName}';
}`
    } else {
      templateStr += `@font-face{
  font-family:'${item.fontName}';
  src:
    url('./${item.fontName}.ttf') format('truetype');
  font-display: swap;
}
.${item.className} {
  font-family: '${item.fontName}';
}`
    }
  })
  return templateStr
}

export {
  compileHTML,
  compileCSS
}